import { Col, Divider, Form, Row } from 'antd';
import React, { useEffect } from 'react';
import CustomInputField from '../atoms/CustomInputField';
import FormField from '../molecules/FormField';
import CustomSelectBox from '../atoms/CustomSelectBox';
import CustomButton from '../atoms/CustomButton';
import { regexOnNumberGraterThanZeroOrEqualToZero } from '../utils';

const ProductPackageItemModal = ({
  poForm,
  modalFormData,
  purchaseUnitList,
  afterCloseModal,
  handleSubmitItemModal,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (modalFormData !== undefined) {
      form.setFieldsValue({
        productCost: modalFormData.productCost,
        taxType: modalFormData.taxType,
        igst: modalFormData.igst,
        sgst: modalFormData.sgst,
        cgst: modalFormData.cgst,
        saleUnitID: modalFormData.saleUnitID,
        discount: modalFormData.discount,
        discountType: modalFormData.discountType,
      });
    }
  }, [modalFormData]);

  const handleSubmitModal = (data) => {
    handleSubmitItemModal(
      data,
      modalFormData.productVariationID,
      poForm ? modalFormData.receivingQTY : modalFormData.orderQTY,
    );
  };

  return (
    <Form layout='vertical' onFinish={handleSubmitModal} name='create_purchase_modal' form={form}>
      <Row gutter={24}>
        <Col span={12}>
          <FormField
            label='Product Cost'
            name='productCost'
            rules={[{ required: true, message: 'Please enter product cost!' }]}
          >
            <CustomInputField type='text' size='large' placeholder='Prodcut Cost' disabled />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Tax Type' name='taxType' rules={[{ required: true, message: 'Select tax type!' }]}>
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a tax type'
              optionFilterProp='label'
              disabled
              options={[
                {
                  value: 'Exclusive',
                  label: 'Exclusive',
                },
                {
                  value: 'Inclusive',
                  label: 'Inclusive',
                },
              ]}
            />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='IGST' name='igst' rules={[{ required: true, message: 'Please enter IGST!' }]}>
            <CustomInputField type='text' placeholder='IGST' size='large' addonAfter={'%'} disabled />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='SGST' name='sgst' rules={[{ required: true, message: 'Please enter SGST!' }]}>
            <CustomInputField type='text' placeholder='SGST' size='large' addonAfter={'%'} disabled />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='CGST' name='cgst' rules={[{ required: true, message: 'Please enter CGST!' }]}>
            <CustomInputField type='text' placeholder='CGST' size='large' addonAfter={'%'} disabled />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Sale Unit' name='saleUnitID' rules={[{ required: true, message: 'Select sale unit!' }]}>
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a sale unit'
              options={purchaseUnitList}
              disabled
            />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Discount Type' name='discountType'>
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a discount type'
              optionFilterProp='label'
              options={[
                {
                  value: 'Percentage',
                  label: 'Percentage',
                },
                {
                  value: 'Fixed',
                  label: 'Fixed',
                },
              ]}
            />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Discount' name='discount' rules={[regexOnNumberGraterThanZeroOrEqualToZero]}>
            <CustomInputField type='text' placeholder='Discount' size='large' />
          </FormField>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Col span={4}>
          <CustomButton type='primary' htmlType='submit' size='large' block>
            Save
          </CustomButton>
        </Col>
        <Col span={4}>
          <CustomButton type='default' size='large' onClick={afterCloseModal} block>
            Cancel
          </CustomButton>
        </Col>
      </Row>
    </Form>
  );
};

export default ProductPackageItemModal;
